export default __webpack_public_path__ + "static/media/FiraSans-Regular.1c0bf072.ttf";